import Pattern from "@assets/PNG/Patterns/Pattern3.png";
import Logo from "@assets/SVG/Logos/MAHBBig.svg";
import { Col, Layout, Row } from "antd";
import styles from "./Layout.module.scss";

export const OnBoarding = (props: any) => {
  return (
    <Layout.Content>
      <Row
        style={{ height: window.innerHeight }}
        align="middle"
      >
        <Col
          xs={{ span: 0 }}
          md={{ span: 12 }}
          className={styles.rightSideSection}
        ></Col>
        <Col
          xs={{ span: 24 }}
          md={{ span: 12 }}
          className={styles.leftSideSection}
          style={{ position: "relative" }}
        >
          <img
            src={Pattern}
            className="absolute top-0 right-0"
            alt="Pattern"
          />

          <img
            src={Logo}
            className="h-16 absolute top-8 right-8"
            alt="Logo"
          />

          <div className={styles.onboardingContentWrapper}>
            <Row
              justify="center"
              align="middle"
              style={{ marginTop: styles.whitespace3, width: "100%" }}
            >
              <Col
                xs={{ span: 24 }}
                md={{ span: 18 }}
              >
                {props.children}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Layout.Content>
  );
};
